import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageContainer from '../../components/layout/PageContainer/PageContainer';
import AdminSearchDetail from '../../components/admin/AdminSearchDetail';
import { useAuth } from '../../hooks/useAuth';

const AdminSearchDetails: React.FC = () => {
  const { user, isAuthenticated, loading, fetchCurrentUser } = useAuth();
  const navigate = useNavigate();
  const userFetchedRef = React.useRef(false);

  React.useEffect(() => {
    if (isAuthenticated && !userFetchedRef.current) {
      fetchCurrentUser();
      userFetchedRef.current = true;
    }
  }, [isAuthenticated, fetchCurrentUser]);

  // Redirect if not admin
  React.useEffect(() => {
    if (!loading) {
      if (!isAuthenticated) {
        navigate('/login');
      } else if (!user || user.is_admin !== true) {
        navigate('/dashboard');
      }
    }
  }, [user, isAuthenticated, loading, navigate]);

  if (loading) {
    return (
      <PageContainer>
        <div className="flex justify-center items-center py-12">
          <span className="text-gray-600">Loading...</span>
        </div>
      </PageContainer>
    );
  }

  return (
    <PageContainer title="Admin - Search Details">
      <AdminSearchDetail />
    </PageContainer>
  );
};

export default AdminSearchDetails; 